import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Canada() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Canada') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [btn, setBtn] = useState('');
    const [cnam, setCnam] = useState('');
    const [type, setType] = useState('');

    const [reseller, setReseller] = useState('');
    const [operator, setOperator] = useState('');
    const [accNum, setAccNum] = useState('');
    const [mobNum, setMobNum] = useState('');
    const [priNum, setPriNum] = useState('');

    const [companyName, setCompanyName] = useState('');
    const [contactName, setContactName] = useState('');
    const [sName, setSName] = useState('');
    const [sType, setSType] = useState('');
    const [sNumber, setSNumber] = useState('');
    const [floor, setFloor] = useState('');
    const [suite, setSuite] = useState('');
    const [city, setCity] = useState('');
    const [province, setProvince] = useState('');
    const [zip, setZip] = useState('');
    const [date, setDate] = useState('');

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setTableDataActive(JSONDATA?.country?.Telephone_Numbers_that_MUST_NOT_BE_PORTED_IN ?? '');
        setTableDataSingle(JSONDATA?.country?.Single_Number ?? '');
        setTableDataRange(JSONDATA?.country?.Number_Range ?? '');

        setBtn(JSONDATA?.country?.BTN ?? '');
        document.querySelector('#btn').value = JSONDATA?.country?.BTN ?? '';
        setCnam(JSONDATA?.country?.cnam ?? '');
        document.querySelector('#cnam').value = JSONDATA?.country?.cnam ?? '';

        setType(JSONDATA?.country?.Type ?? '');
        document.querySelector('#type').value = JSONDATA?.country?.Type ?? '';

        setReseller(JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.Reseller_Name ?? '');
        setOperator(JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.Local_Authorized_Operator_Name ?? '');
        setAccNum(JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.Account_Number ?? '');
        setMobNum(JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.['Main/Pilot_Telephone_Number'] ?? '');
        setPriNum(JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.['PRI-RNIS'] ?? '');
        document.querySelector('#reseller').value = JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.Reseller_Name ?? '';
        document.querySelector('#operator').value = JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.Local_Authorized_Operator_Name ?? '';
        document.querySelector('#accNum').value = JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.Account_Number ?? '';
        document.querySelector('#mobNum').value = JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.['Main/Pilot_Telephone_Number'] ?? '';
        document.querySelector('#priNum').value = JSONDATA?.country?.Identification_of_the_current_AND_losing_Operator?.['PRI-RNIS'] ?? '';

        setCompanyName(JSONDATA?.country?.Requestor_Details?.Company_Name ?? '');
        setContactName(JSONDATA?.country?.Requestor_Details?.Contact_Name ?? '');
        setSName(JSONDATA?.country?.Requestor_Details?.Street_Name ?? '');
        setSType(JSONDATA?.country?.Requestor_Details?.Street_Type ?? '');
        setSNumber(JSONDATA?.country?.Requestor_Details?.Street_Number ?? '');
        setFloor(JSONDATA?.country?.Requestor_Details?.floor ?? '');
        setSuite(JSONDATA?.country?.Requestor_Details?.suite ?? '');
        setCity(JSONDATA?.country?.Requestor_Details?.City ?? '');
        setProvince(JSONDATA?.country?.Requestor_Details?.Province ?? '');
        setZip(JSONDATA?.country?.Requestor_Details?.Zip ?? '');
        document.querySelector('#companyName').value = JSONDATA?.country?.Requestor_Details?.Company_Name ?? '';
        document.querySelector('#contactName').value = JSONDATA?.country?.Requestor_Details?.Contact_Name ?? '';
        document.querySelector('#sName').value = JSONDATA?.country?.Requestor_Details?.Street_Name ?? '';
        document.querySelector('#sType').value = JSONDATA?.country?.Requestor_Details?.Street_Type ?? '';
        document.querySelector('#sNumber').value = JSONDATA?.country?.Requestor_Details?.Street_Number ?? '';
        document.querySelector('#floor').value = JSONDATA?.country?.Requestor_Details?.floor ?? '';
        document.querySelector('#suite').value = JSONDATA?.country?.Requestor_Details?.suite ?? '';
        document.querySelector('#city').value = JSONDATA?.country?.Requestor_Details?.City ?? '';
        document.querySelector('#province').value = JSONDATA?.country?.Requestor_Details?.Province ?? '';
        document.querySelector('#zip').value = JSONDATA?.country?.Requestor_Details?.Zip ?? '';

        setDate(JSONDATA?.country?.Date ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    //--------------------------------table declaration (NOT TO BE PORTED)--------------------------------------//

    const [tableDataActive, setTableDataActive] = useState([{ id: Date.now(), sNum: '', eNum: '' }]);

    //adding a row
    const addRow = () => {
        setTableDataActive([...tableDataActive, { id: Date.now(), sNum: '', eNum: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableDataActive(tableDataActive.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableDataActive.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataActive(updatedData);
    };

    //-------------------------------upload and download table-------------------//

    const [uploadedFileNameRange, setUploadedFileNameRange] = useState('');
    const [uploadedFileNameData, setUploadedFileNameData] = useState('');

    const fileInputRefRange = React.createRef();
    const fileInputRefData = React.createRef();

    const handleFileUpload = (event, target) => {
        const file = event.target.files[0];
        if (!file) return;

        const setFileName = target === 'range' ? setUploadedFileNameRange : setUploadedFileNameData;
        const setTableData = target === 'range' ? setTableDataRange : setTableDataActive;

        setFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);

            const formattedData = dataRows.map((row, index) => {
                const id = index + 1;

                if (target === 'range') {
                    return {
                        id,
                        sNumber: row[0] ? row[0].toString() : '',
                        eNumber: row[1] ? row[1].toString() : '',
                    };
                } else {
                    return {
                        id,
                        sNum: row[0] ? row[0].toString() : '',
                        eNum: row[1] ? row[1].toString() : '',
                    };
                }
            });

            setTableData(formattedData);

            // Separate validation logic for 'range' and 'active'
            const updatedValidation = {};

            formattedData.forEach((row) => {
                const id = row.id;

                if (target === 'range') {
                    const start = row.sNumber;
                    const end = row.eNumber;

                    updatedValidation[`startNumber-${id}`] = /^\d{10}$/.test(start);
                    updatedValidation[`endNumber-${id}`] = /^\d{10}$/.test(end);
                } else {
                    const start = row.sNum;
                    const end = row.eNum;

                    updatedValidation[`startNum-${id}`] = /^\d{10}$/.test(start);
                    updatedValidation[`endNum-${id}`] = /^\d{10}$/.test(end);
                }
            });

            setValidationStates(prev => ({
                ...prev,
                ...updatedValidation,
            }));
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = (target) => {
        if (target === 'range') {
            setUploadedFileNameRange('');
            fileInputRefRange.current.value = '';
            setTableDataRange([]);
        } else if (target === 'data') {
            setUploadedFileNameData('');
            fileInputRefData.current.value = '';
            setTableDataActive([]);
        }
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Canada",
            "Single_Number": tableDataSingle,
            "Number_Range": tableDataRange,
            "Telephone_Numbers_that_MUST_NOT_BE_PORTED_IN": tableDataActive,
            "BTN": btn,
            "cnam": cnam,
            "Type": type,
            "Identification_of_the_current_AND_losing_Operator": {
                "Reseller_Name": reseller,
                "Local_Authorized_Operator_Name": operator,
                "Account_Number": accNum,
                "Main/Pilot_Telephone_Number": mobNum,
                "PRI-RNIS": priNum
            },
            "Requestor_Details": {
                "Company_Name": companyName,
                "Contact_Name": contactName,
                "Street_Name": sName,
                "Street_Type": sType,
                "Street_Number": sNumber,
                "floor": floor,
                "suite": suite,
                "City": city,
                "Province": province,
                "Zip": zip
            },
            "Date": date
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    // console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    useEffect(() => {
        if (type === 'full') {
            setValidationStates(prevState => ({
                ...prevState,
                btn: true,
                ...tableDataActive.reduce((acc, row) => {
                    acc[`startNum-${row.id}`] = true;
                    acc[`endNum-${row.id}`] = true;
                    return acc;
                }, {})
            }));
        }
    }, [type, tableDataActive]);

    async function Submit(e) {
        let validationErrors = {};

        if (!type) {
            validationErrors.type = 'please select the porting type';
        }
        if (type === 'partial' && !btn) {
            validationErrors.btn = 'please fill in the BTN';
        }
        // if (!cnam) {
        //     validationErrors.cnam = 'please fill in the CNAM (Caller Name Delivery)';
        // }
        if (!reseller) {
            validationErrors.reseller = 'please fill in the Reseller Name';
        }
        if (!operator) {
            validationErrors.operator = 'please fill in the Operator Name';
        }
        if (!accNum) {
            validationErrors.accNum = 'please fill in the Account Number';
        }
        if (!mobNum) {
            validationErrors.mobNum = 'please fill in the Main/Pilot Telephone Number';
        }
        if (!companyName) {
            validationErrors.companyName = 'please fill in the Company Name';
        }
        if (!contactName) {
            validationErrors.contactName = 'please fill in the Contact Name';
        }
        if (!sName) {
            validationErrors.sName = 'please fill in the Street Name';
        }
        if (!sType) {
            validationErrors.sType = 'please fill in the Street Type';
        }
        if (!sNumber) {
            validationErrors.sNumber = 'please fill in the Street Number';
        }
        if (!city) {
            validationErrors.city = 'please fill in the City';
        }
        if (!province) {
            validationErrors.province = 'please fill in the Province';
        }
        if (!zip) {
            validationErrors.zip = 'please fill in the Zip';
        }

        // Validate table data only if type is partial
        if (type === 'partial') {
            tableDataActive.forEach(row => {
                if (!/^\d{10}$/.test(row.sNum)) {
                    validationErrors[`startNum-${row.id}`] = 'First number in range must be exactly 10 digits.';
                }
                if (!/^\d{10}$/.test(row.eNum)) {
                    validationErrors[`endNum-${row.id}`] = 'Last number in range must be exactly 10 digits.';
                }
            });
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = accNum + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <p>As the end user subscriber and owner, I designate Orange Business Services, hereafter, <span class="bold-text">Orange Business Services Canada Inc</span>, 1500-770 Rue Sherbrooke, Montréal QC H3A 1G1, CANADA, to act as my agent in changing the Responsible Organization & import each of the telephone number(s) specified on this form.</p>

                </Container>

                <Container>

                    <h4 className='text-decoration-underline'>Single Number</h4> <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableDataSingle.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Immediate validation feedback for 10 digits only when not empty
                                                if (value !== '' && !/^\d{10}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 digits only when not empty
                                                if (row.num !== '' && !/^\d{10}$/.test(row.num)) {
                                                    toast.error('Number must be exactly 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                Enter a 10-digit number (e.g. 9142226250).
                                            </div>
                                        )}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                Number must be exactly 10 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button onClick={() => fileInputRefRange.current.click()} className="inputbox">
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileInputRefRange}
                                onChange={(e) => handleFileUpload(e, 'range')}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileNameRange && (
                                <button onClick={() => removeUploadedFile('range')} className="inputbox">
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove Range File
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileNameRange && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileNameRange}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>First number in range</th>
                                <th>Last number in range</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`} // Corrected ID for num input
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                // Immediate validation feedback for 10 digits
                                                if (value && !/^\d{10}$/.test(value)) { // Only validate if value is not empty
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 digits
                                                if (row.sNumber && !/^\d{10}$/.test(row.sNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be exactly 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter a 10-digit number (e.g. 9142226250).
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`} // Corrected ID for num input
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                // Immediate validation feedback for 10 digits
                                                if (value && !/^\d{10}$/.test(value)) { // Only validate if value is not empty
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 digits
                                                if (row.eNumber && !/^\d{10}$/.test(row.eNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be exactly 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter a 10-digit number (e.g. 9142226250).
                                            </div>
                                        )}
                                    </td>


                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <Col
                        onMouseEnter={() => handleMouseEnter('type')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Porting Type*</label> <br />
                        <select
                            id="type"
                            onChange={(e) => setType(e.target.value)}
                            className={`inputbox ${validationStates.type === false ? 'error' : ''}`}
                            onBlur={() => validateInput('type', /^.*$/)}
                        >
                            <option value=""></option>
                            <option value="partial">
                                Partial
                            </option>
                            <option value="full">
                                Full
                            </option>
                        </select>
                        {hoveredField === 'type' && (
                            <div className="hover-description">
                                Choose the porting type
                            </div>
                        )}
                    </Col>

                    <br></br>

                    <h4 className='text-decoration-underline'>Ranges remain active</h4> <br></br>

                    <Row>
                        <Col>
                            <button onClick={() => fileInputRefData.current.click()} className="inputbox">
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileInputRefData}
                                onChange={(e) => handleFileUpload(e, 'data')}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileNameData && (
                                <button onClick={() => removeUploadedFile('data')} className="inputbox">
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove Data File
                                </button>
                            )}
                        </Col>

                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileNameData && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileNameData}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>First number in range</th>
                                <th>Last number in range</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataActive.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNum-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNum-${row.id}`} // Corrected ID for num input
                                            value={row.sNum}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_table(row.id, 'sNum', value);

                                                // Immediate validation feedback for 10 digits
                                                // Only set the error state if the value is not empty and doesn't match the regex
                                                if (value !== '' && !/^\d{10}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNum-${row.id}`]: false, // Invalid state
                                                    }));
                                                } else {
                                                    // Clear error if the value is either empty or matches the 10-digit regex
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNum-${row.id}`]: true, // Valid state
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNum-${row.id}`] === false ? 'error' : ''}`}
                                        />

                                        {hoveredField === `startNum-${row.id}` && (
                                            <div className="hover-description">
                                                Enter a 10-digit number (e.g. 9142226250).
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNum-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNum-${row.id}`} // Corrected ID for num input
                                            value={row.eNum}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_table(row.id, 'eNum', value);

                                                // Immediate validation feedback for 10 digits
                                                // Only set the error state if the value is not empty and doesn't match the regex
                                                if (value !== '' && !/^\d{10}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNum-${row.id}`]: false, // Invalid state
                                                    }));
                                                } else {
                                                    // Clear error if the value is either empty or matches the 10-digit regex
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNum-${row.id}`]: true, // Valid state
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNum-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 digits
                                                if (row.eNum !== '' && !/^\d{10}$/.test(row.eNum)) {
                                                    toast.error('Number must be exactly 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNum-${row.id}`]: false, // Invalid state
                                                    }));
                                                }
                                            }}
                                        />

                                        {hoveredField === `endNum-${row.id}` && (
                                            <div className="hover-description">
                                                Enter a 10-digit number (e.g. 9142226250).
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataActive.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow}>Add Row</button>

                    <br></br><br></br>

                    <Col
                        onMouseEnter={() => handleMouseEnter('btn')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>MBN/BTN</label> <br />
                        <input
                            onChange={(e) => setBtn(e.target.value)}
                            type="text"
                            id='btn'
                            placeholder=""
                            className={`inputbox ${validationStates.btn === false ? 'error' : ''}`}
                            onBlur={() => {
                                if (btn !== '' && !/^\d{10}$/.test(btn)) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        btn: false,
                                    }));
                                    toast.error('MBN must be exactly 10 digits.');
                                } else {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        btn: true,
                                    }));
                                }
                            }}
                        />
                        {hoveredField === 'btn' && (
                            <div className="hover-description">
                                New Main/Pilot Billing Telephone Number (MBN-BTN) / Leading Telephone Number (T) (e.g. 6046732649).
                            </div>
                        )}
                    </Col>

                    <br></br>

                    {/* <Col
                        onMouseEnter={() => handleMouseEnter('btn')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>MBN/BTN</label> <br />
                        <input
                            onChange={(e) => {
                                setBtn(e.target.value);
                                // Reset validation state on user input
                                if (validationStates.btn === false) {
                                    setValidationStates((prev) => ({
                                        ...prev,
                                        btn: true,
                                    }));
                                }
                            }}
                            type="text"
                            id="btn"
                            placeholder=""
                            className={`inputbox ${type === 'partial' &&
                                    (btn === '' || validationStates.btn === false)
                                    ? 'error'
                                    : ''
                                }`}
                            onBlur={() => {
                                if (type === 'partial') {
                                    if (btn === '') {
                                        setValidationStates((prev) => ({
                                            ...prev,
                                            btn: false,
                                        }));
                                        toast.error('MBN is required for partial porting.');
                                    } else if (!/^\d{10}$/.test(btn)) {
                                        setValidationStates((prev) => ({
                                            ...prev,
                                            btn: false,
                                        }));
                                        toast.error('MBN must be exactly 10 digits.');
                                    } else {
                                        setValidationStates((prev) => ({
                                            ...prev,
                                            btn: true,
                                        }));
                                    }
                                } else {
                                    // For 'full', always mark as valid
                                    setValidationStates((prev) => ({
                                        ...prev,
                                        btn: true,
                                    }));
                                }
                            }}
                        />
                        {hoveredField === 'btn' && (
                            <div className="hover-description">
                                {type === 'partial'
                                    ? 'Enter a 10-digit number (e.g., 9142226900).'
                                    : 'This field is optional for full porting.'}
                            </div>
                        )}
                    </Col> */}

                    <p>(To be specified in case you port the Main/Pilot Number)</p>

                    <p className='heading'>*Please list exhaustively the numbers that you are NOT willing to port which are part of the same circuit, and/or, attached to the same Main/Pilot Telephone Number / Leading Telephone Number. Attention, those numbers won’t be ported-in by Orange</p>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('cnam')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>CNAM (Caller Name Delivery)</label> <br />
                            <input
                                onChange={(e) => setCnam(e.target.value)}
                                type="text"
                                id="cnam"
                                placeholder=""
                                className={`inputbox ${validationStates.cnam === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[a-zA-Z0-9&\s]{1,15}$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, cnam: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'CNAM must be alphanumeric, up to 15 characters, and may include "&" only.'
                                        );
                                    }
                                }}
                            />
                            {hoveredField === 'cnam' && (
                                <div className="hover-description">
                                    (15 characters maximum. No special characters are allowed except "&")
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h4 className='text-decoration-underline'>Identification of the losing carrier</h4> <br></br>

                    <Col
                        onMouseEnter={() => handleMouseEnter('reseller')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Carrier Name*</label>
                        <span className='heading'>(as seen on current bill)</span>
                        <input
                            // onChange={handleInputChangeNumType}
                            onChange={(e) => setReseller(e.target.value)}
                            type="text"
                            id='reseller'
                            placeholder=""
                            className={`inputbox ${validationStates.reseller === false ? 'error' : ''}`}
                            onBlur={() => validateInput('reseller', /[a-zA-Z0-9]/)}

                        />
                        {hoveredField === 'reseller' && (
                            <div className="hover-description">
                                Enter current service provider as seen on current bill if appl.(Telus)
                            </div>
                        )}
                    </Col>

                    <br></br>

                    <Col
                        onMouseEnter={() => handleMouseEnter('operator')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Local Authorized Operator Name*</label> <br />
                        <input
                            // onChange={handleInputChangeNumType}
                            onChange={(e) => setOperator(e.target.value)}
                            type="text"
                            id='operator'
                            placeholder=""
                            className={`inputbox ${validationStates.operator === false ? 'error' : ''}`}
                            onBlur={() => validateInput('operator', /[a-zA-Z0-9]/)}

                        />
                        {hoveredField === 'operator' && (
                            <div className="hover-description">
                                Enter Local Authorized Operator Name
                            </div>
                        )}
                    </Col>

                    <br></br>

                    <Col
                        onMouseEnter={() => handleMouseEnter('accNum')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Account Number*</label>
                        <span className='heading'>(as seen on current bill)</span>
                        <input
                            onChange={(e) => setAccNum(e.target.value)}
                            type="text"
                            id="accNum"
                            placeholder=""
                            className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                            onBlur={() => validateInput('accNum', /\d/)}

                        />
                        {hoveredField === 'accNum' && (
                            <div className="hover-description">
                                End user account number as seen on current bill (e.g. 2382042538)
                            </div>
                        )}
                    </Col>

                    <br></br>

                    <Col
                        onMouseEnter={() => handleMouseEnter('mobNum')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Main billing / leading telephone number*</label>
                        <span className='heading'>(The field is a number that is assimilated to a phone number.)</span>
                        <input
                            onChange={(e) => setMobNum(e.target.value)}
                            type="text"
                            id="mobNum"
                            placeholder=""
                            className={`inputbox ${validationStates.mobNum === false ? 'error' : ''}`}
                            onBlur={() => {
                                // Validate the input on blur: only numbers (with optional decimals)
                                if (!/^\d{10}$/.test(mobNum)) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        mobNum: false,
                                    }));
                                    toast.error('Main Telephone Number must be exactly 10 digits.');
                                } else {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        mobNum: true,
                                    }));
                                }
                            }}
                        />
                        {hoveredField === 'mobNum' && (
                            <div className="hover-description">
                                Main Telephone Number / Leading Telephone Number (e.g. 6046733150)
                            </div>
                        )}
                        {validationStates.mobNum === false && (
                            <div className="error-message">
                                Main Telephone Number must be exactly 10 digits.
                            </div>
                        )}
                    </Col>


                    <br></br>

                    <Col
                        onMouseEnter={() => handleMouseEnter('priNum')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>PRI-RNIS / Megalink Number</label>
                        <span className='heading'>(if appl.)</span>
                        <input
                            onChange={(e) => setPriNum(e.target.value)}
                            type="text"
                            id="priNum"
                            placeholder=""
                            className={`inputbox`}

                        />
                        {hoveredField === 'priNum' && (
                            <div className="hover-description">
                                Primary Rate Interface (PRI), sometimes also called Megalink, it is a TDM, ISDN type (circuit-switched) type telco service, which enables traditional phone lines to carry voice, data and video traffic, among others. We have two types of PRI: E1 (which carry 30 channels in the two pairs of copper lines, common in Europe, India) and T1 (which carry 23/24 channels in the two pairs of copper lines, common in United States).
                            </div>
                        )}
                    </Col>

                </Container>

                <br></br><br></br>

                <Container>

                    <p>I release any third party from liability for acting in accordance with these instructions. <br></br><br></br>

                        I acknowledge being fully liable for the accuracy of the information herein contained and undertake to pay any and all charges incurred by this porting request. <br></br><br></br>

                        I acknowledge that if Equipment record will not be provided with porting request, <span class="bold-text">Orange Business Services Canada Inc</span> may request Equipment record from current provider under additional charge 90 CAD. Customer can get Equipment record from his current provider for free.<br></br><br></br>

                        Understood and Agreed:
                    </p>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name / End Customer Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id='companyName'
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    End Customer Information With Existing Carrier.
                                </div>
                            )}
                        </Col>

                        <br></br>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Name (please print)*</label> <br />
                            <input
                                onChange={(e) => setContactName(e.target.value)}
                                type="text"
                                id='contactName'
                                placeholder=""
                                className={`inputbox ${validationStates.contactName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactName', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'contactName' && (
                                <div className="hover-description">
                                    Portability authorized name (e.g. Ruth Ollie-Wright)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <h6 className='text-decoration-underline'>End customer full address ( <span className='heading'>** Address should be in canada, otherwise it will be rejected</span> ) </h6>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('sName')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Street Name*</label> <br />
                                <input
                                    onChange={(e) => setSName(e.target.value)}
                                    type="text"
                                    id='sName'
                                    placeholder=""
                                    className={`inputbox ${validationStates.sName === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('sName', /[a-zA-Z0-9]/)}
                                />
                                {hoveredField === 'sName' && (
                                    <div className="hover-description">
                                        Address as shown on Customer’s most recent bill from current carrier (e.g. Granville St)
                                    </div>
                                )}
                            </Col>

                            <br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('sType')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Street Type*</label> <br />
                                <input
                                    onChange={(e) => setSType(e.target.value)}
                                    type="text"
                                    id='sType'
                                    placeholder=""
                                    className={`inputbox ${validationStates.sType === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('sType', /^[a-zA-Z0-9\s\W]+$/)}
                                />
                                {hoveredField === 'sType' && (
                                    <div className="hover-description">
                                        Enter the street type.
                                    </div>
                                )}
                            </Col>

                            <br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('sNumber')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Street Number*</label> <br />
                                <input
                                    onChange={(e) => setSNumber(e.target.value)}
                                    type="text"
                                    id='sNumber'
                                    placeholder=""
                                    className={`inputbox ${validationStates.sNumber === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('sNumber', /[a-zA-Z0-9]/)}
                                />
                                {hoveredField === 'sNumber' && (
                                    <div className="hover-description">
                                        Address as shown on Customer’s most recent bill from current carrier (e.g. 725)
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <br></br>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('floor')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Floor</label> <br />
                                <input
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFloor(value);

                                        // Immediate validation feedback
                                        if (value && !/^[a-zA-Z0-9\s\W]+$/.test(value)) { // Only validate if value is not empty
                                            setValidationStates(prev => ({
                                                ...prev,
                                                floor: false,
                                            }));
                                        } else {
                                            setValidationStates(prev => ({
                                                ...prev,
                                                floor: true,
                                            }));
                                        }
                                    }}
                                    type="text"
                                    id="floor"
                                    placeholder=""
                                    className={`inputbox ${validationStates.floor === false ? 'error' : ''}`}
                                    onBlur={() => {
                                        // Final validation check on blur
                                        if (floor && !/^[a-zA-Z0-9\s\W]+$/.test(floor)) { // Only validate if value is not empty
                                            toast.error('Please enter a valid floor number.');
                                            setValidationStates(prev => ({
                                                ...prev,
                                                floor: false,
                                            }));
                                        }
                                    }}
                                />
                                {hoveredField === 'floor' && (
                                    <div className="hover-description">
                                        Enter the floor number.
                                    </div>
                                )}
                            </Col>

                            <br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('suite')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Suite Number</label> <br />
                                <input
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSuite(value);

                                        // Immediate validation feedback
                                        if (value && !/^[a-zA-Z0-9\s\W]+$/.test(value)) { // Only validate if value is not empty
                                            setValidationStates(prev => ({
                                                ...prev,
                                                suite: false,
                                            }));
                                        } else {
                                            setValidationStates(prev => ({
                                                ...prev,
                                                suite: true,
                                            }));
                                        }
                                    }}
                                    type="text"
                                    id="suite"
                                    placeholder=""
                                    className={`inputbox ${validationStates.suite === false ? 'error' : ''}`}
                                    onBlur={() => {
                                        // Final validation check on blur
                                        if (suite && !/^[a-zA-Z0-9\s\W]+$/.test(suite)) { // Only validate if value is not empty
                                            toast.error('Please enter a valid suite number.');
                                            setValidationStates(prev => ({
                                                ...prev,
                                                suite: false,
                                            }));
                                        }
                                    }}
                                />
                                {hoveredField === 'suite' && (
                                    <div className="hover-description">
                                        Enter the suite number.
                                    </div>
                                )}
                            </Col>


                            <br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('city')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>City*</label> <br />
                                <input
                                    onChange={(e) => setCity(e.target.value)}
                                    type="text"
                                    id='city'
                                    placeholder=""
                                    className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('city', /[a-zA-Z0-9]/)}
                                />
                                {hoveredField === 'city' && (
                                    <div className="hover-description">
                                        Address as shown on Customer’s most recent bill from current carrier (e.g. Vancouver)
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <br></br>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('province')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Province*</label> <br />
                                <select
                                    id="province"
                                    onChange={(e) => setProvince(e.target.value)}
                                    className={`inputbox ${validationStates.province === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('province', /^.*$/)}
                                >
                                    <option value=""></option>
                                    <option value="Alberta">
                                        Alberta
                                    </option>
                                    <option value="British Columbia">
                                        British Columbia
                                    </option>
                                    <option value="Manitoba">
                                        Manitoba
                                    </option>
                                    <option value="New Brunswick">
                                        New Brunswick
                                    </option>
                                    <option value="New Foundland and Labrodar">
                                        New Foundland and Labrodar
                                    </option>
                                    <option value="New Scotia">
                                        New Scotia
                                    </option>
                                    <option value="Northwest Territories">
                                        Northwest Territories
                                    </option>
                                    <option value="Nunavut">
                                        Nunavut
                                    </option>
                                    <option value="Ontario">
                                        Ontario
                                    </option>
                                    <option value="Prince Edward Island">
                                        Prince Edward Island
                                    </option>
                                    <option value="Quebec">
                                        Quebec
                                    </option>
                                    <option value="Saskatchewan">
                                        Saskatchewan
                                    </option>
                                    <option value="Yukan Territory">
                                        Yukan Territory
                                    </option>
                                </select>
                                {hoveredField === 'province' && (
                                    <div className="hover-description">
                                        Address as shown on Customer’s most recent bill from current carrier
                                    </div>
                                )}
                            </Col>

                            <br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('zip')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Zip*</label> <br />
                                <input
                                    onChange={(e) => setZip(e.target.value)}
                                    type="text"
                                    id='zip'
                                    placeholder=""
                                    className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('zip', /^[a-zA-Z0-9]{1,6}$/)}
                                />
                                {hoveredField === 'zip' && (
                                    <div className="hover-description">
                                        Address as shown on Customer’s most recent bill from current carrier (e.g. V7Y1K4)
                                    </div>
                                )}
                            </Col>
                        </Row>

                    </Row>

                    <br></br>


                </Container>

                <Container>
                    <Col>
                        <label>Date</label> <br />
                        <input
                            onChange={(e) => setDate(e.target.value)}
                            type="date"
                            id="date"
                            value={date} // Automatically set the current date
                            className={`inputbox`}
                            min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                        />
                    </Col>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Canada;